import type {
  FindOAuthConnectedAppsOutput,
  RevokeOAuthConnectedAppOutput,
} from "schemas/generated/publicMcpOAuth";
import type { RequestFn } from "./request";

import { oauthEndpointContracts } from "schemas/bedrockApi/oauth";

export function createOAuthConnectedAppsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    find: ({
      cursor,
    }: {
      cursor?: string;
    } = {}): Promise<FindOAuthConnectedAppsOutput> => {
      return request<FindOAuthConnectedAppsOutput>({
        method: "GET",
        path: oauthEndpointContracts.connectedAppsList.path,
        query: { cursor },
      });
    },
    revoke: ({
      grantId,
    }: {
      grantId: string;
    }): Promise<RevokeOAuthConnectedAppOutput> => {
      return request<RevokeOAuthConnectedAppOutput>({
        method: "DELETE",
        path: oauthEndpointContracts.connectedAppRevoke.path.replace(
          "{grantId}",
          encodeURIComponent(grantId),
        ),
      });
    },
  };
}
